var e = 0;
export default function (n, t, o) {
  if (!n || !t) throw new Error("astrochimp requires both a URL and a data object");
  var r = document.createElement("script"),
      c = "__astrochimp" + e++;

  function u() {
    window[c] = function () {}, document.head.removeChild(r);
  }

  return r.src = (n + "&" + function (e) {
    for (var n = Object.keys(e), t = [], o = 0; o < n.length; o++) t.push(encodeURIComponent(n[o]) + "=" + encodeURIComponent(e[n[o]]));

    return t.join("&");
  }(t) + "&c=" + c).replace(/post\?u=/, "post-json?u="), window[c] = function (e) {
    if (/[0-9]\s-/.test(e.msg) || "error" === e.result) return o(e, null);
    o(null, e), u();
  }, document.head.appendChild(r), function () {
    u();
  };
}
;